import { useContext, useEffect, useRef, useCallback } from 'react';
import { disableBodyScroll, enableBodyScroll, } from 'body-scroll-lock';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('bodylock');
export function useBodyScrollLock(lockOptions) {
    var isMobile = useContext(MobileContext);
    var scrollableElementRef = useRef(null);
    var lockedElementRef = useRef();
    var isLocked = useRef(false);
    var logRefs = function (message) {
        return logger.log(message, {
            lockedElement: lockedElementRef.current,
            scrollableElement: scrollableElementRef.current,
        });
    };
    var onLock = useCallback(function () {
        if (!isMobile) {
            return;
        }
        var scrollableElement = scrollableElementRef.current;
        var lockedElement = lockedElementRef.current;
        // if it's already locked, nothing to do here
        if (lockedElement === scrollableElement) {
            return;
        }
        // unlock any earlier lock
        if (lockedElement) {
            enableBodyScroll(lockedElement);
            logRefs('Unlocking previous');
            lockedElementRef.current = null;
        }
        // lock the new one
        if (scrollableElement) {
            logRefs('Disabling scroll except');
            disableBodyScroll(scrollableElement, lockOptions);
            lockedElementRef.current = scrollableElement;
            isLocked.current = true;
        }
    }, [isMobile, lockOptions]);
    var onUnlock = useCallback(function () {
        var scrollableElement = scrollableElementRef.current;
        var lockedElement = lockedElementRef.current;
        if (lockedElement) {
            logRefs('Enabling scroll');
            enableBodyScroll(lockedElement);
            // unlock the current target, too, just in case...
            if (scrollableElement) {
                enableBodyScroll(scrollableElement);
            }
            lockedElementRef.current = null;
            isLocked.current = false;
        }
    }, []);
    var setScrollableRef = useCallback(function (node) {
        scrollableElementRef.current = node;
        // if we already have a locked element and it's not the new one... re-lock
        if (isLocked.current) {
            logRefs('Re-locking');
            onLock();
        }
    }, [onLock]);
    useEffect(function () {
        logger.log('Body locking component mounted');
        return function () {
            logger.log('Body locking component unmounted');
            onUnlock();
        };
    }, [isMobile, onUnlock]);
    return { onLock: onLock, onUnlock: onUnlock, setScrollableRef: setScrollableRef, scrollableElementRef: scrollableElementRef };
}
//# sourceMappingURL=useBodyScrollLock.js.map